/**
 * Hero block — slideshow with caption update.
 */
function initHero() {
    var stage = document.getElementById('heroStage');
    if (!stage) return;

    var slides   = stage.querySelectorAll('.slide');
    var dots     = stage.querySelectorAll('.dots button');
    var capTtl   = document.getElementById('capTtl');
    var capCity  = document.getElementById('capCity');
    var current  = 0;
    var interval;

    if (slides.length <= 1) return;

    function goTo(i) {
        slides[current].classList.remove('active');
        dots[current] && dots[current].classList.remove('on');

        current = (i + slides.length) % slides.length;

        slides[current].classList.add('active');
        dots[current] && dots[current].classList.add('on');

        if (capTtl) capTtl.textContent = slides[current].dataset.caption || '';
        if (capCity) capCity.textContent = slides[current].dataset.city || '';
    }

    function start() {
        interval = setInterval(function() { goTo(current + 1); }, 5000);
    }

    function reset() {
        clearInterval(interval);
        start();
    }

    dots.forEach(function(btn) {
        btn.addEventListener('click', function() {
            goTo(parseInt(this.dataset.i, 10));
            reset();
        });
    });

    start();
}
